import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage103 from "../../../../assets/PDFViewerImages/PDFViewerImage103.jpg";
import PDFViewerImage104 from "../../../../assets/PDFViewerImages/PDFViewerImage104.jpg";

const Chapter26 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 26 */}
                <section id="section26" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter26Title}</h2>

                    <div className="image-box">
                        <img src={PDFViewerImage103} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph1}
                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter26Paragraph2}

                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter26Paragraph3}
                    </p>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter26List11}</li>
                        <li>{language.chapter26List12}</li>
                        <li>{language.chapter26List13}</li>
                    </ul>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph4}</p>

                    <ol className="drivers-handbook-list">
                        <li>{language.chapter26List21}</li>
                        <li>{language.chapter26List22}</li>
                        <li>{language.chapter26List23}</li>
                    </ol>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph5}
                    </p>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter26List31}</li>
                        <li>{language.chapter26List32}
                        </li>
                        <li>{language.chapter26List33}
                        </li>
                        <li>{language.chapter26List34}
                        </li>
                    </ul>

                    <h3 className="drivers-handbook-subheading">{language.chapter26Subheading1}</h3>

                    <div className="image-box">
                        <img src={PDFViewerImage104} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph6}
                    </p>

                    <h3 className="drivers-handbook-subheading">{language.chapter26Subheading2}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph7}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph8}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph9}
                    </p>

                    <h3 className="drivers-handbook-subheading">{language.chapter26Subheading3}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph10}
                    </p>

                    <h3 className="drivers-handbook-subheading">{language.chapter26Subheading4}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter26Paragraph11}
                    </p>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter26List41}</li>
                        
                        <li>{language.chapter26List42}</li>
                        
                        <li>{language.chapter26List43}</li>
                        
                        <li>{language.chapter26List44}</li>
                        
                        <li>{language.chapter26List45}</li>
                        
                    </ul>


                </section>


        </>
    )

}

export default Chapter26;
